<template>
    <div
        :class="{ 'l-ss-c-results-is-loading': isLoading, 'l-ss-c-results-skeleton': false }"
        class="l-ss-c-results"
        v-if="isMounted">
        <p
            class="l-ss-c-text-caption"
            v-if="standartType">{{$t('results.otherOffersTitle')}}:
        </p>
        <div class="l-ss-c-results-filters">
            <span
                class="l-ss-c-filters-found-items"
                v-if="$screen.isMobile === false && filterPositionLeft">
                {{ $t('results.foundNumberItems', [total]) }}
            </span>
        </div>

        <slot name="top"></slot>
        <template v-if="isLoading && !hasCachedResults"></template>
        <template v-if="errorText">
            <div class="l-ss-c-empty-results">
                <p class="l-ss-c-text-caption">{{ $t('connectionProblemReload') }}</p>
                <p class="l-ss-c-text-caption">
                    <small>
                        <pre>{{ errorText || 'Connection problem' }}</pre>
                    </small>
                </p>
                <button
                    class="l-ss-c-button l-ss-c-button-large"
                    @click="$emit('page-reload')">
                    {{ $t('connectionProblemReloadButton') }}
                </button>
            </div>
        </template>
        <template v-else>
            <popular-offers
                v-if="offersType === 'popular'"
                :offers="offers"
                @clickEmptyResult="onEmptyResetClick"
                @add-to-cart="offer => $emit('add-to-cart', offer)"/>
            <div v-else>
                <div v-if="hasTopOffers">
                    <h2 class="l-ss-c-results-categories-category-title">
                        <span class="l-ss-c-results-categories-category-title-value">
                            {{ $t('results.topOffersTitle') }}:
                        </span>
                    </h2>&nbsp;
                    <offers-wrapper
                        view="row"
                        :templates="offerTemplates"
                        :offers="topOffers"
                        :offers-type="offersType"
                        @offer-click="params => $emit('offer-click', params)"
                        @add-to-cart="offer => $emit('add-to-cart', offer)"/>
                    <span
                        v-if="groupedOffers && groupedOffers.length"
                        class="l-ss-c-results-section-title l-ss-c-results-section-title-other">
                        {{ $t('results.otherOffersTitle') }}:
                    </span>&nbsp;
                </div>
                <div
                    ref="results-categories"
                    :class="{
                        'l-ss-c-results-categories-is-loading': isLoading,
                        'l-ss-c-results-categories-is-list': !isSinglePageStyle
                    }"
                    class="l-ss-c-results-categories">
                    <template v-if="isSinglePageStyle || !groupCategories">
                        <div class="l-ss-c-results-categories-category l-ss-c-results-categories-is-list">
                            <h2
                                v-if="singleCategory && isNotSingleTopOffer"
                                class="l-ss-c-results-categories-category-title">
                                <i
                                    class="l-ss-c-icon l-ss-c-icon-category-back"
                                    @click="(event) => handleOpenCategory(event, '')"
                                    v-html="iconCategoryBack"
                                    v-show="ind.length > 1"></i>
                                <span
                                    class="l-ss-c-results-categories-category-title-value l-ss-c-results-categories-category-title-is-link"
                                    :title="singleCategory.name"
                                    @click="(event) => handleOpenCategory(event, categoryInArr)">
                                    {{ singleCategory.name || singleCategory.id }}
                                </span>
                                <small
                                    v-if="singleCategory.hits"
                                    class="l-ss-c-count-tag">{{ singleCategory.hits }}</small>
                            </h2>
                            <offers-wrapper
                                :templates="offerTemplates"
                                :offers="otherOffers"
                                :offers-type="offersType"
                                view="grid"
                                :offer-props="{ 'data-page': null }"
                                @offer-click="params => $emit('offer-click', params)"
                                @add-to-cart="offer => $emit('add-to-cart', offer)"/>
                        </div>
                    </template>
                    <div
                        v-else
                        v-for="(group, groupIndex) in groupedOffers"
                        :key="group.category.id"
                        class="l-ss-c-results-categories-category">
                        <div v-if="group.pathCategoryArr">
                            <span
                                v-for="(item , index) in group.pathCategoryArr"
                                :key="index"
                                @click="(event) => handleOpenCategory(event, item)"
                                class="l-ss-c-results-categories-category-path"
                                :class="{ 'l-ss-c-results-url-link': item.url }">
                                <span v-if="index !== (group.pathCategoryArr.length - 1) && item.title">
                                    {{ item.title }} >
                                </span>
                                <span v-if="index === (group.pathCategoryArr.length - 1) && item.title">
                                    {{ item.title }}
                                </span>
                            </span>
                        </div>
                        <h2
                            class="l-ss-c-results-categories-category-title">
                            <span
                                class="l-ss-c-results-categories-category-title-value l-ss-c-results-categories-category-title-is-link">
                                <i
                                    v-if="singleCategory"
                                    class="l-ss-c-icon l-ss-c-icon-category-back"
                                    @click="(event) => handleOpenCategory(event, '')"
                                    v-html="iconCategoryBack"></i>
                                <span @click="(event) => handleOpenCategory(event, group.category)">
                                    {{ group.category.name || group.category.id }}
                                </span>
                            </span>
                            <small
                                v-if="group.category.hits"
                                class="l-ss-c-count-tag">
                                {{ group.category.hits }}
                            </small>
                        </h2>
                        <div
                            v-if="group.pages.length > 0"
                            ref="results-list"
                            class="l-ss-c-results-offers-list">
                            <div
                                v-for="(page, pageIndex) in group.pages"
                                :key="page.length">
                                <div
                                    class="l-ss-c-results-offers-list-page">
                                    <offers-wrapper
                                        :view="groupedOffers.length === 1 ? 'grid' : 'row'"
                                        :templates="offerTemplates"
                                        :offers="page.offers"
                                        :offers-type="offersType"
                                        :offer-props="{
                                            'data-page': page.$page,
                                            'data-group-index': groupIndex,
                                            'data-offers-in-row': page.offers.length,
                                            'data-start-index': getOfferStartIndex(groupIndex),
                                            'data-row': groupIndex + 1,
                                        }"
                                        @offer-click="params => $emit('offer-click', params)"
                                        @add-to-cart="offer => $emit('add-to-cart', offer)">
                                        <div
                                            slot="append"
                                            v-if="pageIndex + 1 === group.pages.length && !isSinglePageStyle && hasNextCategoryItems(group.category.id)"
                                            class=""
                                            :class="classButtonMore">
                                            <div
                                                class="l-ss-c-offer-inner">
                                                <button
                                                    :disabled="isLoading"
                                                    class="l-ss-c-results-offers-show-more-button"
                                                    :class="{ 'l-ss-c-results-offers-show-more-button-rows': $configuration.layout.templateOffer === 'rows' }"
                                                    @click="(event) => handleOpenCategoryWidget(event, group.category)">
                                                    <span class="l-ss-c-results-offers-show-more-count">
                                                        {{ group.category.hits }} {{ compileCategoryHitsName(group.category.hits) }}
                                                    </span>
                                                    <span class="l-ss-c-results-offers-show-more-label">
                                                        {{ $t('results.seeIn') }} «{{ group.category.name || group.category.id }}»
                                                    </span>
                                                    <i
                                                        class="l-ss-c-results-offers-show-more-icon l-ss-c-icon"
                                                        v-html="iconArrowRight"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </offers-wrapper>
                                </div>
                            </div>
                        </div>
                        <div
                            v-else
                            class="l-ss-c-results-empty-message">
                            <template v-if="hasLoadedOnce && !isLoading && !hasResults">
                                <div class="l-ss-c-empty-results">
                                    <button
                                        class="l-ss-c-button l-ss-c-button-large"
                                        @click="onEmptyResetClick">
                                        <template v-if="hasFilters">
                                            {{ $t('categories.emptyListButtonResetFilters') }}
                                        </template>
                                        <template v-else>
                                            {{ $t('categories.emptyListButtonResetQuery') }}
                                        </template>
                                    </button>
                                    <p class="l-ss-c-text-caption">{{ $t('results.emptyResults') }}&nbsp;</p>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
                <div
                    v-if="isSinglePageStyle && (hasPrevResults || hasNextResults)"
                    class="l-ss-c-results-categories-category-actions">
                    <button
                        v-if="hasPrevResults"
                        :disabled="isLoading"
                        class="l-ss-c-button l-ss-c-button-large l-ss-c-button-secondary"
                        @click="event => handleOpenPrevPage(event)">
                        {{ $t('results.prevPage') }}
                    </button>
                    <span
                        v-if="hasPrevResults && hasNextResults"
                        style="padding: 0.5em;"></span>
                    <button
                        v-if="hasNextResults"
                        :disabled="isLoading"
                        class="l-ss-c-button l-ss-c-button-large"
                        @click="event => handleOpenNextPage(event)">
                        {{ $t('results.nextPage') }}&nbsp;{{ nextBottomCount }}
                    </button>
                </div>
                <div>
                    <div class="l-ss-c-results-empty-message">
                        <template v-if="hasLoadedOnce && !isLoading && !hasResults">
                            <template v-if="isSinglePageStyle && singleCategory">
                                <div class="l-ss-c-empty-results">
                                    <p class="l-ss-c-text-caption">
                                        {{ $t('results.emptyCategoryResults') }}&nbsp;<b>{{ singleCategory.name }}</b>
                                        {{ $t('results.emptyCategoryResultsTry') }}&nbsp;
                                    </p>
                                    <button
                                        class="l-ss-c-button l-ss-c-button-large"
                                        @click="onEmptyResetClick">
                                        {{ $t('results.emptyCategoryResultsLink') }}
                                    </button>
                                </div>
                            </template>
                            <template v-else-if="!isLoading">
                                <div class="l-ss-c-empty-results">
                                    <p
                                        class="l-ss-c-text-caption"
                                        v-html="$t('results.emptyResults')"></p>
                                    <button
                                        class="l-ss-c-button l-ss-c-button-large"
                                        @click="onEmptyResetClick">
                                        <template v-if="hasFilters">
                                            {{ $t('categories.emptyListButtonResetFilters') }}
                                        </template>
                                        <template v-else>
                                            {{ $t('categories.emptyListButtonResetQuery') }}
                                        </template>
                                    </button>
                                </div>
                            </template>
                        </template>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import declOfNum from '../helpers/decl-of-num';
    import iconArrowRight from '../assets/images/icons/arrow-right-results.svg';
    import iconCategoryBack from '../assets/images/icons/category-back.svg';
    import OffersWrapper from './offers-wrapper';
    import PopularOffers from '@/core/components/popular';

    const sortByScore = (left, right) => {
        if (left.score > right.score) {
            return -1;
        }
        if (left.score < right.score) {
            return 1;
        }
        return 0;
    };

    export default {
        components: {
            PopularOffers,
            OffersWrapper,
        },
        props: {
            search: {
                type: Object,
                required: false,
                default: () => ({}),
            },
            offerTemplates: {
                type: Object,
                required: false,
            },
            skip: {
                type: [String, Number],
                required: true,
            },
            limit: {
                type: [String, Number],
                required: true,
            },
            categoryId: {
                type: [String, Number, Array],
                required: true,
            },
            isLoading: {
                type: [String, Boolean],
                default: false,
            },
            errorText: {
                type: [String],
                default: '',
            },
            hasResults: {
                type: [String, Boolean],
                default: false,
            },
            hasQuery: {
                type: [String, Boolean],
                default: false,
            },
            hasLoadedOnce: {
                type: [String, Boolean],
                default: false,
            },
            hasFilters: {
                type: [String, Boolean],
                default: false,
            },
            searchRequestId: {
                type: String,
                required: true,
            },
            groupCategories: {
                type: Boolean,
                required: true,
            },
            categories: {
                type: [String, Number, Array],
                required: true,
            },
            total: {
                type: Number,
                required: true,
            },
            filterPositionLeft: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                currentSlideIndex: 0,
                currentCarouselStatus: 0,
                isMounted: false,
                categoryItem: {},
                pathCategory: [],
                ind: [],
            };
        },
        computed: {
            classButtonMore() {
                return (this.$configuration.layout.templateOffer === 'rows') ? 'l-ss-c-offers-item-rows' :
                    'l-ss-c-offers-item l-ss-c-results-categories-category-actions l-ss-c-results-offers-show-more';
            },
            standartType() {
                return this.search?.meta?.searchType?.includes('standard-keyboard') ||
                    this.search?.meta?.searchType?.includes('standard') ||
                    this.search?.meta?.searchType?.includes('standard-autocomplete');
            },
            categoryInArr() {
                return (Array.isArray(this.groupedOffers)) ? this.groupedOffers[0].category : '';
            },
            iconCategoryBack() {
                return iconCategoryBack;
            },
            iconArrowRight() {
                return iconArrowRight;
            },
            hasCachedResults() {
                return this.search && this.search.offers && this.search.offers.length;
            },
            activeCategories() {
                return this.categoryId ?
                    [this.categoryId].flat().map(categoryId => this.getCategoryById(categoryId)) :
                    [];
            },
            singleCategory() {
                return this.activeCategories.length === 1 ? this.activeCategories[0] : null;
            },
            hasActiveCategories() {
                return this.activeCategories && this.activeCategories.length > 0;
            },
            isSinglePageStyle() {
                return Boolean(this.hasActiveCategories || !this.groupCategories);
            },
            offers() {
                const roundUpPrice = (price) => price && Number.isInteger(price) ? price : price ? price.toFixed(1) : null;
                return this.search && this.search.offers ? this.search.offers.map(offer => {
                    return {
                        ...offer,
                        price: roundUpPrice(+offer.price),
                        oldPrice: (roundUpPrice(+offer.oldPrice) !== roundUpPrice(+offer.price)) ? roundUpPrice(+offer.oldPrice) : null,
                    };
                }) : [];
            },
            topOffersIds() {
                return this.search && this.search.topOffersIds ? this.search.topOffersIds : [];
            },
            hasTopOffers() {
                return !!this.topOffersIds.length;
            },
            topOffers() {
                return this.topOffersIds
                    .map(offerId => this.offers.find(item => item.id === offerId)).
                    filter(item => !!item).
                    sort(sortByScore);
            },
            offersType() {
                return this.search?.type;
            },
            otherOffers() {
                return this.offers.filter(item => !this.topOffersIds.includes(item.id));
            },
            groupedOffers() {
                const grouped = this.otherOffers.reduce((memo, offer, index) => {
                    memo[offer.category.id] = memo[offer.category.id] || {
                        category: this.getCategoryById(offer.category.id) || offer.category,
                        offers: [],
                        pages: {},
                        sortIndex: index,
                        startPage: null,
                        categoryItem: [],
                    };
                    memo[offer.category.id].offers.push(offer);
                    memo[offer.category.id].categoryItem = (this.categories) ? this.categories.find(category => +category.id === +memo[offer.category.id].category.id) : {};

                    memo[offer.category.id].pathCategory = function (categories , item = {}) {
                        memo[offer.category.id].pathCategoryArr = [];
                        if (item.parentId) {
                            memo[offer.category.id].categoryItem = categories.find(category => +category.id === +item.parentId);
                            memo[offer.category.id].pathCategoryArr.push(memo[offer.category.id].categoryItem);
                            if (memo[offer.category.id].categoryItem.parentId) memo[offer.category.id].pathCategory(categories , memo[offer.category.id].categoryItem);
                        }
                        return memo[offer.category.id].pathCategoryArr;
                    };

                    memo[offer.category.id].pathCategory(this.categories , memo[offer.category.id].categoryItem);

                    const page = offer.$page === undefined ? null : offer.$page;

                    if (page !== null && (memo[offer.category.id].startPage === null || memo[offer.category.id].startPage > page)) {
                        memo[offer.category.id].startPage = page;
                    }

                    memo[offer.category.id].pages[page] = memo[offer.category.id].pages[page] || {
                        $page: page,
                        $pageLast: false,
                        offers: [],
                    };
                    memo[offer.category.id].pages[page].offers.push(offer);

                    if (offer.$pageLast) {
                        memo[offer.category.id].pages[page].$pageLast = true;
                    }
                    return memo;
                }, {});

                Object.keys(grouped).forEach(key => {
                    grouped[key].pages = Object.values(grouped[key].pages)
                        .sort((left, right) => {
                            if (left.$page > right.$page) return 1;
                            else if (left.$page < right.$page) return -1;
                            else return 0;
                        });
                });

                return Object.values(grouped).sort((a, b) => a.sortIndex - b.sortIndex);
            },
            hasPrevResults() {
                return this.skip > 0;
            },
            hasNextResults() {
                if (!this.hasResults) {
                    return false;
                }
                return Boolean(this.getNextPageCount(this.skip, this.limit, this.activeCategories));
            },
            nextBottomCount() {
                return this.getNextPageCount(this.skip, this.limit);
            },
            isNotSingleTopOffer() {
                return !this.topOffers.length || this.topOffers.length && this.topOffers.length !== this.offers.length;
            },
        },
        mounted() {
            if (this.isSinglePageStyle || !this.groupCategories) {
                this.categoryItem = this.categories.find(category => +category.id === +this.categoryId);
                let pathCategory = (categories , item = {}) => {
                    let categoryItem = {};
                    if (item.parentId) {
                        categoryItem = categories.find(category => +category.id === +item.parentId);
                        this.pathCategory.push(categoryItem);
                        if (categoryItem.parentId) pathCategory(categories , categoryItem);
                    }
                    return this.pathCategory;
                };
                this.pathCategory = pathCategory(this.categories , this.categoryItem);
                this.$set(this.pathCategory, this.pathCategory.indexOf(this.categoryItem ), this.categoryItem );
            }

            this.$nextTick(() => {
                this.isMounted = true;
            });
            if (this.$configuration.customScript) {
                eval(this.$configuration.customScript);
            }
        },
        methods: {
            getNextPageCount(skip, limit, category) {
                const hasCategory = category instanceof Array ? category.length > 0 : Boolean(category);
                const hits = hasCategory ?
                    [category].flat().reduce((result, category) => result + (category || {}).hits || 0, 0) :
                    this.search.hits;
                const active = skip + limit;
                if (active < (hits - limit)) {
                    return this.limit;
                }
                let value = hits - active;
                return value > 0 ? value : 0;
            },
            getCategoryById(categoryId) {
                if (categoryId && this.search && this.search.categories) {
                    return this.search.categories.find(category => category.id.toString() === categoryId.toString());
                }
                return null;
            },
            getOffersByCategoryId(categoryId) {
                const group = this.groupedOffers.find(group => group.category.id.toString() === categoryId.toString());
                return group ? group.offers : [];
            },
            hasNextCategoryItems(categoryId) {
                const offers = this.getOffersByCategoryId(categoryId);
                const category = this.getCategoryById(categoryId);
                if (!category) {
                    return false;
                }
                return category && offers.length < category.hits;
            },
            handleOpenCategory(event, category) {
                event.preventDefault();
                event.stopPropagation();
                let categoryId = category.id;
                let categoryItem = this.categories.find(category => +category.id === +categoryId);
                if (categoryItem && !category.url) {
                    category.url = categoryItem.url;
                }
                if (category.url) {
                    window.open(category.url, this.$configuration.linkTargetBlank ? '_blank' : '_self');
                } else {
                    this.$emit('navigate-category', { categoryId, skip: 0 });
                }
            },
            handleOpenCategoryWidget(event, category) {
                event.preventDefault();
                event.stopPropagation();
                let categoryId = category.id;
                this.$emit('navigate-category', { categoryId, skip: 0 });
            },
            handleOpenPrevPage(event) {
                event.preventDefault();
                event.stopPropagation();
                this.$emit('navigate-page-prev');
                let tag = document.getElementsByTagName('searchbooster-search-popup');
                let popap = tag[0].shadowRoot.querySelector('.l-ss-c-search-popup-wrapper-mask');
                popap.scrollTop = 0;
            },
            handleOpenNextPage(event) {
                event.preventDefault();
                event.stopPropagation();

                this.$emit('navigate-page-next');
                let tag = document.getElementsByTagName('searchbooster-search-popup');
                let popap = tag[0].shadowRoot.querySelector('.l-ss-c-search-popup-wrapper-mask');
                popap.scrollTop = 0;
            },
            onEmptyResetClick(event) {
                event.preventDefault();
                event.stopPropagation();
                if (this.hasActiveCategories) {
                    this.$emit('reset-category');
                } else if (this.hasFilters) {
                    this.$emit('reset-filters');
                } else {
                    this.$emit('reset-query');
                }
            },
            compileCategoryHitsName(hits) {
                return declOfNum(hits, [
                    this.$t('results.seeMore1'),
                    this.$t('results.seeMore2'),
                    this.$t('results.seeMore3'),
                ]);
            },
            getOfferStartIndex(groupIndex) {
                return this.groupedOffers.slice(0, groupIndex).reduce((accumulator, currentValue, index) => {
                    if (groupIndex !== index) {
                        return accumulator + currentValue.offers.length;
                    }
                }, 0);
            },
        },
    };
</script>
